var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "기본정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.isOld && !_vm.disabled && _vm.editable,
                                expression: "isOld && !disabled && editable",
                              },
                            ],
                            attrs: {
                              isSubmit: _vm.isComplete,
                              url: _vm.completeUrl,
                              param: _vm.patrol,
                              mappingType: "PUT",
                              label: "점검완료",
                              icon: "check",
                            },
                            on: {
                              beforeAction: _vm.completePatrol,
                              btnCallback: _vm.completePatrolCallback,
                            },
                          }),
                          _vm.isOld && !_vm.deleteFlag && _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  label: "LBLREMOVE",
                                  icon: "delete_forever",
                                },
                                on: { btnClicked: _vm.remove },
                              })
                            : _vm._e(),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.disabled && _vm.editable,
                                expression: "!disabled && editable",
                              },
                            ],
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.patrol,
                              mappingType: _vm.saveType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.savePlan,
                              btnCallback: _vm.saveCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable && !_vm.isOld,
                            type: "edit",
                            name: "plantCd",
                          },
                          on: { datachange: _vm.datachange },
                          model: {
                            value: _vm.patrol.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "plantCd", $$v)
                            },
                            expression: "patrol.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-dept", {
                          attrs: {
                            required: "",
                            plantCd: _vm.patrol.plantCd,
                            commonDept:
                              _vm.popupParam.patrolTypeCd == "PTC0000001"
                                ? true
                                : false,
                            disabled: _vm.disabled,
                            editable: _vm.editable && !_vm.isOld,
                            label:
                              _vm.popupParam.patrolTypeCd == "PTC0000001"
                                ? "점검 주관부서"
                                : "점검 대상부서",
                            name: "deptCd",
                          },
                          on: { input: _vm.changeDeptCd },
                          model: {
                            value: _vm.patrol.deptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "deptCd", $$v)
                            },
                            expression: "patrol.deptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable && !_vm.isOld,
                            label: "점검일",
                            type: "date",
                            name: "patrolDate",
                          },
                          model: {
                            value: _vm.patrol.patrolDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "patrolDate", $$v)
                            },
                            expression: "patrol.patrolDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            type: "edit",
                            editable: false,
                            codeGroupCd: "PATROL_TYPE_CD",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "patrolTypeCd",
                            label: "점검구분",
                          },
                          model: {
                            value: _vm.patrol.patrolTypeCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "patrolTypeCd", $$v)
                            },
                            expression: "patrol.patrolTypeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.popupParam.patrolTypeCd == "PTC0000001"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                          },
                          [
                            _c("c-vendor", {
                              attrs: {
                                required: "",
                                disabled: _vm.disabled,
                                editable: _vm.editable && !_vm.isOld,
                                label: "점검 대상업체",
                                name: "vendorCd",
                                selfFlag: false,
                                plantCd: _vm.patrol.plantCd,
                              },
                              on: { input: _vm.vendorItems },
                              model: {
                                value: _vm.patrol.vendorCd,
                                callback: function ($$v) {
                                  _vm.$set(_vm.patrol, "vendorCd", $$v)
                                },
                                expression: "patrol.vendorCd",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable && !_vm.isOld,
                            deptCd: _vm.patrol.deptCd,
                            type: "user",
                            label: "점검자",
                            name: "sopMapId",
                          },
                          model: {
                            value: _vm.patrol.sopMapId,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "sopMapId", $$v)
                            },
                            expression: "patrol.sopMapId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-table",
                {
                  ref: "grid",
                  attrs: {
                    title: "LBL00001613",
                    columns: _vm.grid.columns,
                    gridHeight: _vm.grid.height,
                    data: _vm.patrol.results,
                    filtering: false,
                    isExcelDown: false,
                    columnSetting: false,
                    usePaging: false,
                    noDataLabel: _vm.$message("MSG0000752"),
                    hideBottom: true,
                    editable: _vm.editable && !_vm.disabled,
                    rowKey: "saiPatrolItemId",
                    selection: "multiple",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "suffixTitle" },
                    [
                      _c(
                        "font",
                        {
                          staticStyle: {
                            "font-size": "0.9em",
                            "font-weight": "400",
                            color: "red",
                          },
                        },
                        [_vm._v(" O:양호 △:미흡 X:불량")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.patrol.patrolTypeCd == "PTC0000002" &&
                          _vm.isENVHEADept
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLADD",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addResult },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.patrol.results.length > 0 &&
                          _vm.patrol.patrolTypeCd == "PTC0000002" &&
                          _vm.isENVHEADept
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLEXCEPT",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeResult },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-table",
                {
                  ref: "gridimpr",
                  attrs: {
                    title: "유해위험요인 도출",
                    columns: _vm.gridimpr.columns,
                    gridHeight: _vm.gridimpr.height,
                    data: _vm.patrol.imprs,
                    columnSetting: false,
                    isExcelDown: false,
                    usePaging: false,
                    filtering: false,
                    noDataLabel: "도출된 유해위험요인이 없습니다.",
                    hideBottom: true,
                    editable: _vm.editable && !_vm.disabled,
                    rowKey: "saiPatrolImprId",
                    selection: "multiple",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "link" && _vm.editable && _vm.disabled
                            ? [
                                _c("q-btn", {
                                  attrs: {
                                    push: "",
                                    size: "xs",
                                    icon: "search",
                                    color: "blue-6",
                                    round: "",
                                    dense: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.linkImprDetail(props.row)
                                    },
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "suffixTitle" },
                    [
                      _c("q-icon", {
                        staticClass: "text-green",
                        staticStyle: {
                          "font-size": "1.3em !important",
                          "font-weight": "400",
                        },
                        attrs: { name: "sentiment_satisfied_alt" },
                      }),
                      _c(
                        "font",
                        {
                          staticStyle: {
                            "font-size": "0.9em",
                            "font-weight": "400",
                            color: "red",
                          },
                        },
                        [
                          _vm._v(
                            " 점검완료 시 도출된 유해위험요인들은 안전보건팀에 전달됩니다."
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLADD",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addImpr },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.patrol.imprs.length > 0
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLEXCEPT",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeImpr },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }